const faStarRegular = {
  prefix: 'far',
  iconName: 'star',
  icon: [
    576,
    512,
    [11088, 61446],
    'f005',
    'M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c10 1.5 18.2 8.5 21.3 18.1s.5 20.1-6.7 27l-111.4 108.5 26.2 153.5c1.7 9.9-2.4 20-10.7 25.9s-19.2 6.7-28.1 2l-137-71.9L171.8 512c-8.9 4.7-19.8 4-28.1-2s-12.4-16-10.7-25.9l26.2-153.5L47.9 222.6c-7.2-7-9.8-17.5-6.7-27s11.3-16.6 21.3-18.1l153.2-22.6L284.2 13.5C288.3 5.2 296.7 0 287.9 0zm0 79l-52.5 108.1c-3.5 7.1-10.2 12.1-18.1 13.3l-119 17.5 86.1 83.9c5.7 5.6 8.3 13.6 7 21.5l-20.3 119.2 106.4-55.9c7-3.7 15.4-3.7 22.4 0l106.4 55.9-20.3-119.2c-1.3-7.9 1.3-15.9 7-21.5l86.1-83.9-119-17.5c-7.9-1.2-14.6-6.2-18.1-13.3L287.9 79z',
  ],
};
export default faStarRegular;
